import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterTaskNumberComponent } from './table-filter-task-number.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  declarations: [TableFilterTaskNumberComponent],
  exports: [TableFilterTaskNumberComponent],
})

export class TableFilterTaskNumberModule {
}
